module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-1-e7f1da616f359cd58f28f56e4de71720.webp";